import { createContext, ReactNode, useContext } from 'react';

export type HandleModalProps = {
	toggleModal: () => void;
	isOpen: boolean;
	triggerComponentId?: string;
};

type ProviderType = {
	children: ReactNode;
	isOpen: boolean;
	setIsOpen: (o: boolean) => void;
	triggerComponentId?: string;
};

const HandleModal = createContext<HandleModalProps>({ isOpen: false } as HandleModalProps);

const provideHandleModal = (isOpen: boolean, setIsOpen: (o: boolean) => void) => {
	const toggleModal = () => {
		setIsOpen(!isOpen);
	};

	return {
		isOpen,
		toggleModal,
	};
};

const HandleModalProvider = ({ children, ...rest }: ProviderType) => {
	const value = provideHandleModal(rest.isOpen, rest.setIsOpen);

	return (
		<HandleModal.Provider value={{ ...value, triggerComponentId: rest.triggerComponentId }}>
			{children}
		</HandleModal.Provider>
	);
};

export const useHandleModal = () => useContext(HandleModal);

export default HandleModalProvider;
